export const my = require('./my');